export const sizes = {
  sm: 'px-2.5 py-1.5',
  md: 'min-h-10 py-2 px-3',
  lg: 'min-h-11 py-2.5 px-3.5',
};
